"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nlZones = void 0;
var nlZones = exports.nlZones = [{
  id: 'AMSTERDAM',
  name: 'Amsterdam',
  country: 'NL',
  cornerNW: {
    latitude: 52.4311,
    longitude: 4.7291
  },
  cornerSE: {
    latitude: 52.2784,
    longitude: 5.0679
  },
  subZones: [{
    name: 'Amsterdam Centrum',
    zipcodes: {
      1011: {
        label: '1011'
      }
    }
  }, {
    name: 'Amsterdam Quartier rouge',
    zipcodes: {
      1012: {
        label: '1012'
      }
    }
  }, {
    name: 'Amsterdam Museumsplein',
    zipcodes: {
      1016: {
        label: '1016'
      }
    }
  }, {
    name: 'Amsterdam Zuid',
    zipcodes: {
      1018: {
        label: '1018'
      }
    }
  }, {
    name: 'Amsterdam Watergraafsmeer',
    zipcodes: {
      1019: {
        label: '1019'
      }
    }
  }, {
    name: 'Amsterdam De Pijp',
    zipcodes: {
      1054: {
        label: '1054'
      }
    }
  }, {
    name: 'Amsterdam Oud-Zuid',
    zipcodes: {
      1071: {
        label: '1071'
      }
    }
  }]
}];